import { ICopyable } from '../core/copyable.interface';
import { IUser } from './interface/user.interface';

export class User implements ICopyable<User> {
    id: string = null;
    email: string = null;
    firstName: string = null;
    lastName: string = null;
    displayName: string = null;
    phoneNumber: string = null;
    mobileNumber: string = null;
    faxNumber: string = null;
    groupParentId: string = null;
    culture: string = null;
    account: string = null;
    password: string = null;
    confirmPassword: string = null;
    roles: number[] = null;
    paramSetId: number = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): User {
        const instance = new User();
        instance.id = this.id;
        instance.email = this.email;
        instance.firstName = this.firstName;
        instance.lastName = this.lastName;
        instance.displayName = this.displayName;
        instance.phoneNumber = this.phoneNumber;
        instance.mobileNumber = this.mobileNumber;
        instance.faxNumber = this.faxNumber;
        instance.groupParentId = this.groupParentId;
        instance.culture = this.culture;
        instance.account = this.account;
        instance.password = this.password;
        instance.confirmPassword = this.confirmPassword;
        instance.roles = [...this.roles];
        instance.paramSetId = this.paramSetId;

        return instance;
    }

    public static createFormCopy(user: IUser): User {
        const instance = new User();
        instance.id = user.id;
        instance.email = user.email;
        instance.firstName = user.firstName;
        instance.lastName = user.lastName;
        instance.displayName = user.displayName;
        instance.phoneNumber = user.phoneNumber;
        instance.mobileNumber = user.mobileNumber;
        instance.faxNumber = user.faxNumber;
        instance.groupParentId = user.groupParentId;
        instance.culture = user.culture;
        instance.account = user.account;
        instance.password = user.password;
        instance.confirmPassword = user.confirmPassword;
        instance.roles = [...user.roles];
        instance.paramSetId = user.paramSetId;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.email = other.email;
        this.firstName = other.firstName;
        this.lastName = other.lastName;
        this.displayName = other.displayName;
        this.phoneNumber = other.phoneNumber;
        this.mobileNumber = other.mobileNumber;
        this.faxNumber = other.faxNumber;
        this.groupParentId = other.groupParentId;
        this.culture = other.culture;
        this.account = other.account;
        this.password = other.password;
        this.confirmPassword = other.confirmPassword;
        this.roles = [...other.roles];
        this.paramSetId = other.paramSetId;
    }

    public GetDisplayName() {
        return `${this.displayName} (id: ${this.id})`;
    }
}
